import { render, staticRenderFns } from "./addOrEditStudent.vue?vue&type=template&id=599b2e83&scoped=true&"
import script from "./addOrEditStudent.vue?vue&type=script&lang=js&"
export * from "./addOrEditStudent.vue?vue&type=script&lang=js&"
import style0 from "./addOrEditStudent.vue?vue&type=style&index=0&id=599b2e83&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "599b2e83",
  null
  
)

export default component.exports